/* global BX, arNextOptions */
import {refreshBasketFly} from './refresh-basket-fly';
import {closeBasket} from './open-basket-fly';
(function () {
    const selectors = {
        basket: '.basket_fly',
        removeAllButton: '.remove_all_basket',
    };

    const classes = {
        disabled: 'disabled',
    };
    let basketParamsCache = null;
    function getBasketParams() {
        if (basketParamsCache) return basketParamsCache;

        const input = document.querySelector('#fly_basket_params');

        if (!input) {
            throw new Error('fly_basket_params not found');
        }

        basketParamsCache = input.value;

        return basketParamsCache;
    }
    async function clearSection(type) {
        const form = document.querySelector('#basket_form');

        if (!form) {
            throw new Error('Basket form not found');
        }
        const params = getBasketParams();
        let index = 1;

        switch (type) {
            case 'delay':
                index = 2;
                break;

            case 'na':
                index = 4;
                break;
        }

        const body = new URLSearchParams({
            PARAMS: params,
            TYPE: index,
            CLEAR_ALL: 'Y',
        });

        const response = await fetch(`${arNextOptions.SITE_DIR}ajax/show_basket_fly.php`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            },
            body,
        });

        if (!response.ok) {
            throw new Error(`HTTP ${response.status}`);
        }

        return response.text();
    }

    function resetCatalogButtons() {
        document.querySelectorAll('.to-cart').forEach((button) => {
            button.classList.remove('clicked');
            button.style.display = '';
        });

        document.querySelectorAll('.in-cart').forEach((button) => {
            button.style.display = 'none';
        });

        document.querySelectorAll('.wish_item').forEach((button) => {
            button.classList.remove('added');
        });

        document.querySelectorAll('.counter_block').forEach((counter) => {
            counter.style.display = '';
        });

        document.querySelectorAll('.button_block').forEach((block) => {
            block.classList.remove('wide');
        });
    }

    async function handleRemoveAll(event) {
        const button = event.target.closest(selectors.removeAllButton);

        if (!button) {
            return;
        }

        event.preventDefault();

        if (button.classList.contains(classes.disabled)) {
            return;
        }

        const type = button.dataset.type;

        if (!type) {
            return;
        }

        button.classList.add(classes.disabled);

        try {
            await clearSection(type);

            resetCatalogButtons();

            await refreshBasketFly();
            closeBasket(document.querySelector(selectors.basket));
            if (window.BX?.onCustomEvent) {
                BX.onCustomEvent('onCompleteAction', [{action: 'loadBasket'}]);
            }
        } catch (error) {
            console.error('Basket clear error:', error);
        } finally {
            button.classList.remove(classes.disabled);
        }
    }

    function initBasketFlyClear() {
        document.addEventListener('click', handleRemoveAll);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initBasketFlyClear);
    } else {
        initBasketFlyClear();
    }
})();
